import { useState } from "react";
import Table from "../../utils/utilities/Table/Table";

import InventoryRoundedIcon from '@mui/icons-material/InventoryRounded';

import { headers, filters, tabs } from "./config";

const AppointmentList = () => {

  return (
    <Table tableId="appointments" title="Appointment" icon={InventoryRoundedIcon} headers={headers} filters={filters} defaultSort="-start_time" idKey="appointment_id" fieldsToSearch={["Event", "Customer Name", "Customer Phone"]} tabs={tabs} tabField="status" defaultTab="scheduled" edit={false} additionalCollections={"c:full_name,c:mobile_phone"} exportCsv={true} />
  );
};

export default AppointmentList;